import { render, staticRenderFns } from "./PosCombobox.vue?vue&type=template&id=618c0969&"
import script from "./PosCombobox.vue?vue&type=script&lang=js&"
export * from "./PosCombobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports